import type { GroupedPlayerRewardDto, RewardTypeValue } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import type { ExtendedProgressStatusDto } from '@/queries/progress-statuses/progress-statuses.schema';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

export const FIRST_PLAYER_LEVEL = 1;

// A reward unlocks once the player reaches its grouped reward's minimum level.
// The Level-up Scratch Card is the exception: it is already available on the first level.
export const checkRewardDisabled = (
  type: RewardTypeValue | undefined,
  groupedReward: GroupedPlayerRewardDto | undefined,
  playerLevel: number,
) => {
  if (type === GamificationRewardType.LevelUp && playerLevel === FIRST_PLAYER_LEVEL) {
    return false;
  }

  return !groupedReward?.minLevelFrom || playerLevel < groupedReward.minLevelFrom;
};

interface RewardLockParams {
  type: RewardTypeValue | undefined;
  groupedRewards: GroupedPlayerRewardDto[] | undefined;
  progressStatuses: ExtendedProgressStatusDto[] | undefined;
  playerLevel: number;
}

// Both lists are short (one grouped reward per reward type, a handful of statuses),
// so a direct lookup per reward is enough.
export const getRewardLock = ({ type, groupedRewards, progressStatuses, playerLevel }: RewardLockParams) => {
  const groupedReward = groupedRewards?.find(item => item.type === type);
  const requiredStatus = groupedReward
    ? progressStatuses?.find(status => status.levelFrom === groupedReward.minLevelFrom)
    : undefined;

  return {
    groupedReward,
    statusName: requiredStatus?.name,
    isDisabled: checkRewardDisabled(type, groupedReward, playerLevel),
  };
};
